import "../App.css";

export default function Biographie() {
  return (
    <main
      className="biographie-container"
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "16px",
        fontFamily: "Georgia, serif",
        lineHeight: "1.6",
      }}
    >
      <div className="biographie-text">
        <h1 style={{ textAlign: "center", marginBottom: "24px" }}>
          SERAPHIN CLERC (1853-1910) L'INVENTEUR OUBLIÉ
        </h1>

        {/* --- Destiné à devenir un inventeur --- */}
        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_01.jpg"
            alt="Rue d'Octodure à Martigny"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        <h2>Destiné à devenir un inventeur</h2>
        <p>
          Le 30 mars 1853, dans la paisible ville de Martigny, nichée au cœur
          des montagnes suisses du Valais, naît Joseph-Séraphin Clerc, un jeune garçon au destin extraordinaire. Son père, Maurice-Anselme Clerc, un artisan doué et inventeur passionné, remarque tôt l'attrait de son fils pour la mécanique. Dès son plus jeune âge, Séraphin passe des heures à démonter et à réassembler des objets, avide de comprendre les rouages de ce monde mécanique qui l'entoure.
À l'âge de quatorze ans, Séraphin commence son apprentissage dans l'atelier de son père. C'est là qu'il acquiert les compétences fondamentales en mécanique qui façonneront son destin. Son père, impressionné par son ingéniosité, voit en lui un potentiel prometteur.

        </p>

        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_06.jpg"
            alt="Apprentissage"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        {/* --- L'Éclosion à Paris --- */}
        <h2>L'Éclosion à Paris</h2>
        <p>
          En 1870, conseillé par son père, Séraphin Clerc décide de s'inscrire à
          l'École des Arts et Métiers d'Angers, une institution prestigieuse réputée pour former de brillants ingénieurs et artisans. Son séjour à l'école s'étend sur trois années cruciales, de 1870 à 1873, une période qui façonne son avenir et lui fournit les compétences nécessaires pour réaliser ses ambitions.
À l'école, Séraphin se plonge avec passion dans l'étude de la mécanique, de la thermodynamique, de l'électricité, et de bien d'autres domaines. Il est un étudiant dévoué, assoiffé de connaissance, et ses enseignants ne tardent pas à reconnaître son talent exceptionnel.
Ses camarades le considèrent comme un véritable génie, toujours prêt à partager ses idées novatrices et à aider ses pairs à surmonter les défis académiques. Il est non seulement un brillant scientifique, mais aussi un innovateur né, constamment à la recherche de moyens d'améliorer et de révolutionner les machines et les mécanismes.
L'école lui offre un environnement riche en ressources et en opportunités pour expérimenter et développer ses compétences en ingénierie. Au fil des années, il travaille sur une série de projets ambitieux, des machines automatisées aux moteurs plus efficaces. C'est à l'École des Arts et Métiers d'Angers qu'il perfectionne ses compétences en conception, en mécanique, et en ingénierie, ce qui s'avérera essentiel pour sa carrière future.
Cependant, son temps à l'école n'est pas sans défis. La France est en pleine transformation après la guerre de 1870, et le climat politique et social est tendu. Malgré ces difficultés, Séraphin Clerc persiste dans sa quête du savoir et de l'excellence en ingénierie.

        </p>

        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_02.jpg"
            alt="Angers"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        <p>
          À la fin de sa formation en 1873, Séraphin est devenu un ingénieur
          qualifié, prêt à mettre en pratique tout ce qu'il a appris. Il sait que Paris est le lieu où il peut réaliser ses rêves, et il est déterminé à laisser sa marque sur le monde de l'innovation.
Arborant fièrement son diplôme de l'École des Arts et Métiers d'Angers, Séraphin Clerc quitte l'établissement éducatif, armé de connaissances et de compétences qui le propulseront vers un avenir exceptionnel en tant qu'inventeur visionnaire.
En 1873, il ouvre un petit atelier de mécanique au 5 rue Clauzel. À l'étage supérieur du même bâtiment se trouve l'atelier du peintre Julien Le Blant, une coïncidence qui marquera le début d'une amitié fidèle pour le reste de leur vie.
<div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_12.jpg"
            alt="Julien Le Blant"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>
La France émerge à peine de la guerre de 1870, une défaite humiliante qui pousse le gouvernement à revoir entièrement son arsenal militaire. Séraphin, doté d'un esprit inventif inépuisable, fourmille d'idées révolutionnaires pour moderniser l'armée. Cependant, il lui manque les ressources financières nécessaires pour concrétiser ses projets ambitieux.
Il décide alors de solliciter l'armée et présente à l'État-major plusieurs machines innovantes. Ses concepts, bien qu'en avance sur leur époque, sont souvent abandonnés en cours d'expérimentation ou repris par d'autres inventeurs qui les améliorent. Malgré les obstacles, Séraphin persévère.

        </p>

        {/* --- Les Grandes Inventions --- */}
        <h2>Les Grandes Inventions</h2>
        <p>
          En 1885, Séraphin Clerc est fier de présenter une machine remarquable
          à l'Exposition Universelle d'Anvers : le Chronos, une invention fondée sur une fusion audacieuse de mécanique, d'électricité et de physique quantique. 
        </p>
        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_08.jpg"
            alt="Anvers"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        <p>
          ...L'affaire Dreyfus, un scandale militaire et politique majeur en
          France, et politique majeur en France à la fin du XIXe siècle, mêle involontairement Séraphin Clerc à un complot international. Au cœur de cette affaire se trouve le capitaine Alfred Dreyfus, un officier français injustement accusé de trahison pour avoir transmis des documents secrets à l'ennemi. Parmi ceux-ci, se trouvent des plans et des schémas de Séraphin Clerc, dont le Chronos et le Céphaloscope. Ces documents détaillés, bien qu'encore au stade de prototypes et de concepts, sont considérés comme des secrets militaires précieux en raison de leur potentiel révolutionnaire dans le domaine de la défense et de l'espionnage. On va découvrir plus tard que c'est Esterhazy, un officier de l'armée française et un traître notoire, qui était secrètement en contact avec les services secrets allemands et à vendu des informations confidentielles à l'Allemagne pour son propre bénéfice. C'est au cours de ses activités d'espionnage, que Esterhazy a découvert les plans de Séraphin Clerc dans les archives de l'armée française. Il a réalisé immédiatement la valeur de ces documents, qui contiennent des informations pouvant être utilisées pour développer des armes et des dispositifs d'espionnage avancés. Sous une fausse identité, Esterhazy a vendu les plans de Séraphin Clerc à des agents de la Prusse.
Lorsque la trahison d'Esterhazy est révélée, Séraphin Clerc, même s'il est involontairement mêlé à cette affaire, ne peut que constater la gravité de la situation et se demander si ses plans, conçus pour l'avancement de la science et de la technologie, seront utilisés par l'ennemi à des fins bien plus sinistres.

        </p>

        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_14.jpg"
            alt="Esterhazy"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        {/* --- Une intrigue amoureuse et une disparition mystérieuse --- */}
        <h2>Une intrigue amoureuse et une disparition mystérieuse</h2>
        <p>
          Le 16 septembre 1910, Séraphin Clerc embarque à bord d'un train en
          direction de Genève. Cependant, à son arrivée à la gare de Cornavin, il ne reste aucune trace de lui, à l'exception d'une valise vide. La disparition mystérieuse de Séraphin soulève de nombreuses questions. Certains spéculent qu'il aurait été éliminé par les services secrets français pour empêcher la Prusse de s'emparer de ses inventions révolutionnaires. À une époque où les grandes puissances se préparent à une guerre imminente, les machines de Séraphin suscitent un intérêt massif. 
        </p>

        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_10.jpg"
            alt="Genève"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        <p>
          On apprendra plus tard que Séraphin Clerc avait un rendez-vous galant
          avec une certaine Margaretha Zelle, mieux connue sous le nom de Mata
          Hari. Leur relation reste un mélange de romance et d'intrigue et a fait l'objet de nombreuses spéculations au fil des ans. Était-ce une véritable histoire d'amour ou un piège tendu à Séraphin Clerc ?
Mata Hari était une danseuse exotique néerlandaise de renommée mondiale. Elle sera également soupçonnée d'être une espionne pendant la Première Guerre mondiale. Leurs chemins se croisent pour la première fois dans les cercles artistiques et intellectuels de Paris, une ville qui est le foyer de l'innovation, de l'art et du mystère. Il est clair que Séraphin est éperdument amoureux. Cependant, l'ombre de l'espionnage plane déjà sur Mata Hari. On la soupçonne de travailler pour le compte de diverses puissances étrangères. Séraphin, qui ignore probablement les activités d'espionnage de Mata Hari aurait pu être manipulé dans cette relation. La question de savoir pour qui travaillait Mata Hari reste un mystère. Elle a été accusée d'espionnage au service de l'Allemagne, de la France et d'autres pays. Ses véritables affiliations restent floues, mais ce qui est clair, c'est que sa liaison avec Séraphin Clerc ajoute une couche de complexité à son histoire. La fin tragique de Mata Hari, fusillée en 1917 pour espionnage, éclaire certains aspects de son rôle d'espionne présumée. Sa liaison teintée de mystère et d'intrigue avec Séraphin Clerc, continue de captiver l'imagination, en faisant l'une des romances les plus énigmatiques de l'histoire.

        </p>

        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <img
            src="/images/biographie/bio_13.jpg"
            alt="Mata Hari"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </div>

        {/* --- Le Retour en Grâce de Séraphin --- */}
        <h2>Le Retour en Grâce de Séraphin</h2>
        <p>
          La découverte des carnets et des correspondances de Séraphin Clerc
          ravive l'intérêt pour son héritage. Des universitaires, des
          scientifiques et des historiens du monde entier se lancent dans
          l'exploration de ses idées et de ses inventions. Ses créations
          novatrices, autrefois considérées comme impossibles à réaliser, sont
          réexaminées à la lumière des connaissances technologiques actuelles.
          Des musées exposent ses maquettes et prototypes, permettant au grand
          public de découvrir son génie. Les écoles et universités intègrent son
          histoire dans leurs programmes éducatifs. Le nom de Séraphin Clerc,
          longtemps oublié, devient un symbole de créativité, de persévérance et
          d'innovation. L'histoire de Joseph-Séraphin Clerc, longtemps
          ensevelie dans l'obscurité, renaît finalement pour inspirer les
          générations futures à poursuivre leurs rêves et à repousser les
          frontières de la connaissance. Sa contribution à la science et à la
          technologie est désormais pleinement reconnue, faisant de lui un héros
          méconnu de l'histoire.
        </p>
        <p>
          Le monde contemporain, animé par la technologie et l'innovation,
          commence à redécouvrir l'homme qui vivait autrefois dans l'ombre des
          grands inventeurs de son époque. Ainsi, l'histoire de
          Joseph-Séraphin Clerc renaît de l'obscurité, son héritage perdure à
          travers les générations, inspirant de nouveaux inventeurs à repousser
          les frontières de la science et de la technologie.
        </p>
      </div>
    </main>
  );
}
